var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quota-notice-step"},[_c('PlateTitle',{attrs:{"title":"保函开立须知"}}),_c('div',{staticClass:"notice-content",domProps:{"textContent":_vm._s(_vm.normalizedNotice)}}),_c('a-checkbox',{model:{value:(_vm.agreed),callback:function ($$v) {_vm.agreed=$$v},expression:"agreed"}},[_vm._v(" 我已阅读并同意上述保函开立须知 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }